<template>
  <span>
    <v-row no-gutters align="center" class="style-row" v-if="hasCopyAll && hasCopyButton">
      <v-spacer />
      <v-col cols="1" class="text-left">
        <v-tooltip bottom>
          <template #activator="{on}">
            <v-icon size="18" class="pb-1 pr-1" v-on="on" @click="setClassesValues(true)">
              mdi-content-copy
            </v-icon>
          </template>
          {{ $i18n.t(`dialog.style.copyAll${$_capitalize(styleType)}Properties`) }}
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters :align="computedAlign" class="style-row">
      <v-col v-if="!hideTitleCol" :cols="titleCols" :class="titleClasses.join(' ')" class="text-left style-title-text">
        {{ title }}:
      </v-col>
      <v-col :cols="inputCols" :class="inputClasses.join(' ')" class="text-left">
        <slot :name="name">
          <data-input v-bind="$attrs" v-model="computedValue" />
        </slot>
      </v-col>
      <slot :name="`${name}.input.append`" />
      <v-spacer />
      <v-col cols="1" class="text-left" v-if="hasCopyButton">
        <v-tooltip bottom>
          <template #activator="{on}">
            <v-icon size="18" class="pb-1 pr-1" v-on="on" @click="setClassesValues(false)">
              mdi-content-copy
            </v-icon>
          </template>
          {{ $i18n.t('dialog.style.copyStyleProperty', { name: title }) }}
        </v-tooltip>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import DataInput from '@/components/DataInput';
export default {
  name: 'StyleDialogStyleRow',
  components: {
    DataInput,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      required: false,
    },
    subProperties: {
      type: Array,
    },
    copyMainParamWithSubsProps: {
      type: Boolean,
      default: false,
    },
    subValues: {
      type: Object,
    },
    translationPath: {
      type: String,
      default: () => {
        return '';
      },
    },
    straightTitle: {
      type: String,
      default: () => {
        return '';
      },
    },
    inputCols: {
      type: [Number, String],
      default: () => {
        return 5;
      },
    },
    inputClasses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    titleCols: {
      type: [Number, String],
      default: () => {
        return 5;
      },
    },
    titleClasses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    hideTitleCol: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hasCopyAll: {
      type: Boolean,
      default: false,
    },
    hasCopyButton: {
      type: Boolean,
      default: false,
    },
    styleType: {
      type: String,
      validator: v => {
        return ['style', 'label'].includes(v);
      },
    },
    stylePropsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    computedAlign() {
      return this.$attrs.dataType?.name === 'slider' || this.$attrs.dataType?.name === 'color' ? 'center' : 'baseline';
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    title() {
      return `${this.straightTitle || this.$i18n.t(this.translationPath) || ''}`;
    },
  },
  methods: {
    setClassesValues(all = false) {
      this.$root.$emit(
        'setClassesValues',
        all
          ? {
              styleType: this.styleType,
              stylePropsList: this.stylePropsList,
            }
          : {
              property: this.name,
              value: this.computedValue,
              styleType: this.styleType,
              propertyTranslation: this.title,
              ...(this.subProperties && this.subValues
                ? {
                    subValues: this.subValues,
                    subPropertiesToDelete: this.subProperties.filter(
                      subProp => !Object.keys(this.subValues).includes(subProp)
                    ),
                    copyMainParamWithSubsProps: this.copyMainParamWithSubsProps,
                  }
                : {}),
            }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.style-row {
  min-height: 50px;
}
.style-title-text {
  font-family: Roboto;
  font-size: 13px;
  line-height: 15px;
  color: #202124;
}
</style>
